import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CircularProgress from "components/CircularProgress";
import IntlMessages from "util/IntlMessages";

class DeleteConfirmationModal extends React.Component {
  render() {
    const closeBtn = (
      <button className="close" onClick={this.props.toggle}>
        &times;
      </button>
    );

    return (
      <div>
        <Modal isOpen={this.props.modal} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle} close={closeBtn}>
            <IntlMessages id={`${this.props.body}.header`} />
          </ModalHeader>
          <ModalBody className="">
            <IntlMessages id={`${this.props.body}.body`} />
          </ModalBody>
          <ModalFooter>
            <React.Fragment>
              <Button
                size="md"
                className="btn btn-light"
                onClick={() => {
                  this.props.toggle();
                }}
              >
                <IntlMessages id={`${this.props.body}.no`} />
              </Button>
              <Button
                className="btn btn-vibo2"
                size="md"
                onClick={() => {
                  this.props.apiDelete();
                }}
              >
                <IntlMessages id={`${this.props.body}.yes`} />
              </Button>
            </React.Fragment>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default DeleteConfirmationModal;



// WEBPACK FOOTER //
// ./components/DeleteConfirmationModal/index.js